"use client"

import {useTheme} from "next-themes"
import {Toaster as Sonner, ToasterProps} from "sonner"

const Toaster = ({...props}: ToasterProps) => {
    const {theme = "system"} = useTheme()

    return (
        <Sonner
            theme={theme as ToasterProps["theme"]}
            className="toaster group"
            style={
                {
                    "--normal-bg": "#22292f", // normal toast background
                    "--normal-text": "#fff",
                    "--normal-border": "#111827",
                    "--error-bg": "#b91c1c", // strong red for error
                    "--error-text": "#fff",
                    "--error-border": "#7f1d1d",
                } as React.CSSProperties
            }
            {...props}
        />
    )
}

export {Toaster}
